enum ViewType {
    local = 1,
    remote = 2,
    both = 3
}

export default ViewType;